import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { MAINTENANCE_APP_CODE, MAINTENANCE_APP_CODE_HEADER } from "../constants/maintenance.constants";
import { isOnMaintenancePage, redirectToMaintenancePage } from "../maintenance/maintenance-check";

/** Maintenance Interceptor
 * Identifies the application with the X-App-Code header on every API call, and redirects to the maintenance page
 * on the 503 sent by the API middleware while the application is in maintenance.
 */
@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.apiConfig.uri) || isOnMaintenancePage()) {
      return next.handle(request);
    }

    const requestWithAppCode = request.clone({
      setHeaders: { [MAINTENANCE_APP_CODE_HEADER]: MAINTENANCE_APP_CODE },
    });
    return next.handle(requestWithAppCode).pipe(
      catchError((error: HttpErrorResponse) => {
        // Only the 503 sent by the maintenance middleware carries the application code
        if (error.status === 503 && error.error?.appCode === MAINTENANCE_APP_CODE) {
          redirectToMaintenancePage(error.error?.message);
        }
        return throwError(() => error);
      })
    );
  }
}
